import { Column, Row } from 'react-table';
import { evaluateColumnExportPolicy, isAnyInclude, isExplicitInclude } from '../ExcelTableColumn';
import { isMenuColumn } from './isMenuColumn';
import { toExcelColumn } from './toExcelColumn';
import { createWorksheet, ExcelWorksheet } from '@fluentsms/utils';

export function toWorksheet<TRow extends Record<string, unknown>>(props: {
  name: string;
  rows: Row<TRow>[];
  visibleColumns: Column<TRow>[];
  prepareRow: (row: Row<TRow>) => void;
  selectedRowIds: Record<string, boolean>;
}): ExcelWorksheet {
  const { name, rows, prepareRow, visibleColumns, selectedRowIds } = props;

  for (const row of rows) {
    prepareRow(row);
  }

  const excelRows = rows.map((row) => row.original);
  const excelColumns = visibleColumns
    .filter((column) => {
      const policy = evaluateColumnExportPolicy(column);

      if (isMenuColumn(column)) {
        return isExplicitInclude(policy);
      }

      return isAnyInclude(policy);
    })
    .map((column) =>
      toExcelColumn(column, {
        selectedRowIds,
      }),
    );

  return createWorksheet({
    name,
    rows: excelRows,
    columns: excelColumns,
  });
}
